import { affordableHousingComApi } from "api/affordableHousingCom";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";
import { AhLeadUsageTracker } from "views/settings-integration/integrations/affordable-housing-com/AhLeadUsageTracker";
import { useAhLeadUsage } from "views/settings-integration/integrations/affordable-housing-com/useAhLeadUsage";

export const AffordableHousingComView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();
  const ahLeadUsage = useAhLeadUsage();

  const { mutate: disconnectAffordableHousingCom, isPending: isDisconnecting } =
    useMutation({
      mutationKey: ["AFFORDABLE_HOUSING_COM", "DELETE"],
      mutationFn: () => affordableHousingComApi.disconnect(),
      onSuccess: () => {
        toast.success(
          "AffordableHousing.com integration disconnected successfully"
        );
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.AFFORDABLE_HOUSING_COM}
          name="AffordableHousing.com"
          path="/settings/integration/affordable-housing-com"
          onDisconnect={() => disconnectAffordableHousingCom()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        {ahLeadUsage ? (
          <div className="bg-white rounded-lg border border-alpha-100 p-6">
            <AhLeadUsageTracker usage={ahLeadUsage} />
          </div>
        ) : null}
        <FeedListingsCard
          feed="affordable_housing_com"
          feedLabel="AffordableHousing.com"
        />
      </div>
    </Layout>
  );
};
